<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.compact"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center justify-center h-20 mt-3 mb-4">
      <img class="w-10" src="assets/images/logo/logo-text-on-dark.svg" alt="Logo image">
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <button mat-icon-button [matMenuTriggerFor]="modulesMenu" aria-label="Módulos">
      <mat-icon [svgIcon]="'heroicons_outline:squares-2x2'"></mat-icon>
    </button>
    <mat-menu #modulesMenu="matMenu">
      <a mat-menu-item *ngFor="let module of modules" [routerLink]="module.link">
        <mat-icon [svgIcon]="module.icon"></mat-icon>
        <span>{{ module.title }}</span>
      </a>
    </mat-menu>
    <div class="text-2xl md:text-2xl font-semibold truncate ml-3">{{ moduleName }}</div>
    <app-empresa-ativa class="ml-6"></app-empresa-ativa>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <languages *ngIf="false"></languages>
      <messages *ngIf="false"></messages>
      <app-tenant-switch></app-tenant-switch>
      <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button> -->
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div
    class="relative flex flex-0 items-center w-full h-14 px-4 md:px-6 z-49 border-t print:hidden"
    [ngClass]="isAmbienteTeste ? 'justify-between bg-yellow-100 dark:bg-yellow-900' : 'justify-start bg-card dark:bg-transparent'">
    <ng-container *transloco="let t">
      <span class="font-medium text-secondary">
        {{ t('common.company_name')}} &copy; {{currentYear}}.
      </span>
      <span *ngIf="isAmbienteTeste" class="font-semibold text-yellow-800 dark:text-yellow-200">Ambiente de testes</span>
    </ng-container>
  </div>

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
